export enum BookmarksRouteName {
    Verses = 'bookmarks-verses',
    Hadiths = 'bookmarks-hadiths',
    Duas = 'bookmarks-duas'
}
